var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { action, computed, makeObservable, observable } from "mobx";
import { logger } from "../logger/store-logger";
export var FilteredStates;
(function (FilteredStates) {
    FilteredStates["LoggedOut"] = "LoggedOut";
})(FilteredStates || (FilteredStates = {}));
export class QueueStatsStore {
    constructor(agentStore) {
        this.selectedQueueId = "";
        this.subscriberIds = new Set();
        makeObservable(this);
        this.agentStore = agentStore;
    }
    get selectedQueueAgents() {
        if (!this.selectedQueueId) {
            return observable.array([]);
        }
        const agents = Array.from(this.agentStore.agents.values());
        const filteredAgents = agents.filter((agent) => {
            return (agent.associatedQueueIds &&
                agent.associatedQueueIds.includes(this.selectedQueueId) &&
                !Object.values(FilteredStates).includes(agent.globalState));
        });
        return observable.array(filteredAgents.map(this.mapAgentToAgentRow));
    }
    subscribeToQueueStats() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                // For now we are only using the agent store to get the selected agents
                // this will be updated later to also make use of the queue stats service
                const subscriberId = yield this.agentStore.subscribeToAgentStatus();
                this.subscriberIds.add(subscriberId);
                return subscriberId;
            }
            catch (error) {
                logger.error("[QueueStatsStore] Error subscribing to queue stats", error);
                throw error;
            }
        });
    }
    stopQueueStatsUpdates(subscriberId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (subscriberId) {
                    yield this.agentStore.stopAgentStatusUpdates(subscriberId);
                    this.subscriberIds.delete(subscriberId);
                }
            }
            catch (error) {
                logger.error("[QueueStatsStore] Error stopping queue stats updates", error);
            }
        });
    }
    setSelectedQueue(queueId) {
        this.selectedQueueId = queueId;
    }
    mapAgentToAgentRow(agent) {
        var _a, _b;
        return {
            agentId: agent.agentId,
            agent: { name: agent.agentName, email: agent.agentEmail },
            teamName: agent.teamName,
            agentState: agent.globalState,
            timeInState: {
                duration: agent.globalStateTimestamp,
                createdTime: agent.globalStateTimestamp,
                isActive: true
            },
            skillsProfile: (_a = agent.skillsProfile) !== null && _a !== void 0 ? _a : "",
            associatedQueueIds: (_b = agent.associatedQueueIds) !== null && _b !== void 0 ? _b : []
        };
    }
}
__decorate([
    observable
], QueueStatsStore.prototype, "selectedQueueId", void 0);
__decorate([
    computed
], QueueStatsStore.prototype, "selectedQueueAgents", null);
__decorate([
    action
], QueueStatsStore.prototype, "setSelectedQueue", null);
